import { useHistory } from "react-router-dom";
import queryString from "qs";
import { useXWingspanExpansion } from "../../../../shared/hooks/useXWingspanExpansion";
import {
  PAYEES_ALL_PATH,
  PAYEES_ARCHIVED_PATH,
  PAYEES_COMPLETE_PATH,
  PAYEES_DETAILS_ROUTE,
  PAYEES_INCOMPLETE_PATH,
  PAYEES_NOT_SIGNED_UP_PATH,
  PAYEES_SEARCH_PATH
} from "../../utils";
import { matchPath } from "react-router";

const ignoredRoutes = [
  PAYEES_ALL_PATH,
  PAYEES_INCOMPLETE_PATH,
  PAYEES_COMPLETE_PATH,
  PAYEES_ARCHIVED_PATH,
  PAYEES_NOT_SIGNED_UP_PATH,
  PAYEES_SEARCH_PATH
];

export const useXWingspanPayerId = () => {
  const history = useHistory();
  const xWingspanExpansion = useXWingspanExpansion();

  const payerIdValue = queryString.parse(history.location.search, {
    ignoreQueryPrefix: true
  }).payerId as string | string[];

  const payerId = typeof payerIdValue === "string" ? payerIdValue : undefined;

  const isPayeeDetailsRoute =
    matchPath(history.location.pathname, PAYEES_DETAILS_ROUTE) &&
    !ignoredRoutes.includes(history.location.pathname);

  return xWingspanExpansion && isPayeeDetailsRoute && payerId
    ? payerId
    : undefined;
};
